/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Collapse, Form, Flex, Row, Col, Space, Card, message } from "antd";
import { Input, Button, Table, Typography, DatePicker } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from "../../../hooks/useAccessPageState";
import dayjs from "dayjs";
import DeliveryNoteService from "../../../service/ERP/DeliveryNote.service";
import "./MyPage.css";

const delService = DeliveryNoteService();
const { RangePicker } = DatePicker;

const mngConfig = { title: "", textOk: null, textCancel: null, action: "create", code: null };

const DeliveryNoteAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (data?.dlvdate) {
        const [dlvdate_form, dlvdate_to] = data.dlvdate.map((m) =>
          dayjs(m).format("YYYY-MM-DD")
        );
        Object.assign(data, { dlvdate_form, dlvdate_to });
        delete data.dlvdate;
      }
      delService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => setAccessData(res.data?.data || []))
        .catch(() => message.error("Request error!"));
    };

    if (useAccessPageState.canUseForcedSearchValues?.(forcedValues)) {
      runSearch(forcedValues);
      return;
    }
    form.validateFields().then((v) => runSearch(v));
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    handleSearch({}, restoreDefaultPagination());
  };

  const handleAdd = () => {
    navigate("manage/create", {
      state: { config: { ...mngConfig, title: "Create Delivery Note", action: "create" } },
    });
  };

  const handleView = (record) => {
    navigate("manage/view", {
      state: {
        config: { ...mngConfig, title: "View Delivery Note", action: "view", code: record?.delcode },
      },
    });
  };

  const handleEdit = (record) => {
    navigate("manage/edit", {
      state: {
        config: { ...mngConfig, title: "Edit Delivery Note", action: "edit", code: record?.delcode },
      },
    });
  };

  const handleDelete = async (record) => {
    try {
      await delService.deleted(record?.delcode);
      message.success("ลบสำเร็จ");
      handleSearch();
    } catch {
      message.error("ลบไม่สำเร็จ");
    }
  };

  const handlePrint = (record) => {
    window.open(`/del-print/${record?.delcode}`, "_blank");
  };

  /* Packing List เป็นเอกสารแยก ต้องสร้างก่อนถึงจะพิมพ์ได้
     ปุ่มนี้จึงพาไปหน้าสร้าง พร้อมดึงใบส่งมอบใบนี้มาให้เลย */
  const handleCreatePackingList = (record) => {
    navigate("/ERP/packing-list/manage/create", {
      state: {
        config: {
          title: "Create Packing List",
          action: "create",
          code: null,
          delcode: record?.delcode,
        },
      },
    });
  };

  const handleCreateInvoice = (record) => {
    navigate("/ERP/invoice/manage/create", {
      state: {
        config: {
          title: "Create Invoice",
          action: "create",
          code: null,
          jocode: record?.jocode,
        },
      },
    });
  };

  useEffect(() => {
    const restored = restoreState();
    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
  }, []);

  const FormSearch = (
    <Collapse
      size="small"
      bordered={false}
      activeKey={activeSearch}
      onChange={setActiveSearch}
      items={[
        {
          key: "1",
          label: <><SearchOutlined /><span> ค้นหา</span></>,
          showArrow: false,
          children: (
            <>
              <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="เลขที่ใบส่งมอบ" name="delcode">
                      <Input placeholder="Enter Delivery Code" onChange={handleSearch} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="Job Order" name="jocode">
                      <Input placeholder="Enter JO Code" onChange={handleSearch} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="ชื่อลูกค้า" name="cusname">
                      <Input placeholder="Enter Customer Name" onChange={handleSearch} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="Brand" name="brand">
                      <Input placeholder="Enter Brand" onChange={handleSearch} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="วันที่ส่งมอบ" name="dlvdate">
                      <RangePicker
                        placeholder={["From Date", "To Date"]}
                        style={{ width: "100%", height: 40 }}
                        onChange={handleSearch}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={12} md={12} lg={12} xl={12} />
                  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary" size="small" className="bn-action"
                        icon={<SearchOutlined />} onClick={() => handleSearch()}
                      >ค้นหา</Button>
                      <Button
                        type="primary" size="small" className="bn-action" danger
                        icon={<ClearOutlined />} onClick={handleClear}
                      >ล้าง</Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
        },
      ]}
    />
  );

  const allColumns = accessColumn({ handleView, handleEdit, handleDelete, handlePrint, handleCreatePackingList, handleCreateInvoice });

  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */

  const { columns: column, settingsButton } = useColumnSettings(

    "delivery_note_access_cols",

    allColumns

  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Typography.Title className="m-0 !text-zinc-800" level={3}>
          Delivery Note
        </Typography.Title>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={handleAdd}
          >
            Create Delivery Note
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  return (
    <div className="delivery-note-access">
      <Space direction="vertical" size="middle" style={{ display: "flex", position: "relative" }}>
        {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="delcode"
                columns={column}
                dataSource={accessData}
                scroll={{ x: "max-content" }}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default DeliveryNoteAccess;
